module.exports = __webpack_public_path__ + "static/media/vegitables_50.787accbc.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_50.csv
// module id = 636
// module chunks = 0